import { render, staticRenderFns } from "./SocialPageLinks.vue?vue&type=template&id=275ab05c&scoped=true&"
import script from "./SocialPageLinks.vue?vue&type=script&lang=ts&"
export * from "./SocialPageLinks.vue?vue&type=script&lang=ts&"
import style0 from "./SocialPageLinks.vue?vue&type=style&index=0&id=275ab05c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ab05c",
  null
  
)

export default component.exports